import { getIntentById,addIntentListPublic, getAllIntentsbyBot, addIntent,addIntentPublic, updateIntent, deleteIntent, getAllIntentsPublic } from '@/api/intent.service.js'
import { getBotById } from '@/api/bot.service.js'

export default {
  state:{
    intent: {},
    intents: [],
    intentsPub: []
  },
  getters:{
    getIntent(state){
      return state.intent
    },
    getAllIntent(state){
      return state.intents
    },
    getAllIntentsPublic(state){
      return state.intentsPub
    }
  },
  mutations:{
    // getAllIntentsPublic(state, intents){
    //   state.intentsPub = intents
    // },
    setAllIntentsPublic(state, intents){
      state.intentsPub = intents
    },
    setAllIntents(state, intents){
      state.intents = intents
    },
    setIntent(state, intent){
      state.intent = intent
    },
    addIntent(state, newintent){
      state.intent = newintent
      state.intents.splice(0,0, newintent)
    },
    addIntentListPublic(state, newintent){
      state.intent = newintent
      state.intents.splice(0,0, newintent)
    },
    updateIntent(state, upIntent){
      state.intent = upIntent
    }
  },
  actions:{
    async setAllIntents(context,id){
      let intents = await getAllIntentsbyBot(id)
      let infoIntents = new Array
      console.log ('intents',intents)
      console.log ('infoIntents',infoIntents)
      intents.forEach(el => {
        getIntentById(el._id).then((data) => {
          infoIntents.splice(0,0,data)
        })
      });
      context.commit('setAllIntents', infoIntents)
    },
    async setAllIntentsPublic(context){
      let intents = await getAllIntentsPublic()
      
      context.commit('setAllIntentsPublic', intents)
    },

    
    async setIntent(context, id){
      let ut = await getIntentById(id)
      context.commit('setIntent', ut)
    },
    async addIntent(context, intent) {
      let bot = await getBotById(intent.bot._id)
      intent.bot.name = bot.name
      let newintent = await addIntent(intent)
      context.commit('addIntent', newintent)
      if(intent.public){
        let intents = await getAllIntentsPublic()
        context.commit('setAllIntentsPublic', intents)
      }
    },
    async addIntentListPublic(context, intent) {
      let bot = await getBotById(intent.intent.bot._id)
      intent.bot.name = bot.name
      let newintent = await addIntentListPublic(intent)
      context.commit('addIntentListPublic', newintent)
      if(intent.public){
        let intents = await getAllIntentsPublic()
        context.commit('setAllIntentsPublic', intents)
      }
    },
    async updateIntent(context, intent) {
      let upIntent = await updateIntent(intent)
      context.commit('updateIntent', upIntent)
      if(intent.public){
        let intents = await getAllIntentsPublic()
        context.commit('setAllIntentsPublic', intents)
      }
    },
    async deleteIntent(context, obj) {
      let upIntent = await deleteIntent(obj)
      context.commit('setAllIntents', upIntent)
      
    },
    
  }
}


// WEBPACK FOOTER //
// ./src/store/intent.store.js